import NearbyModel from '../pages/nearby/nearby-model';
import NearbyView from '../pages/nearby/nearby-view';

export default class SidebarPresenter {
  constructor(appInterface) {
    this.model = new NearbyModel();
    this.view = new NearbyView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.model.loadUserState();

    if (!this.model.isAuthenticated) {
      this.view.showGuestSidebar(() => this.appInterface.navigateTo('auth'));
      if (this.appInterface.reinitTooltips)
        this.appInterface.reinitTooltips();
      return;
    }

    this.view.showSidebarLoading();

    try {
      if (!this.model.currentUserLocation) {
        try {
          const loc = await this.model.getUserLocation();
          this.model.setCurrentUserLocation(loc);
        } catch (_) {
          // ignore location errors
        }
      }

      const users = await this.model.loadNearbyUsersData(
        this.model.currentUserLocation,
        this.model.nearbyDistance
      );

      this.view.renderSidebarUsers(
        users,
        this.model.currentUserLocation,
        () => this.appInterface.toggleDistanceDialog()
      );
      if (this.appInterface.reinitTooltips)
        this.appInterface.reinitTooltips();

      for (const user of users) {
        if (user.lat && user.lon) {
          try {
            const name = await this.model.getLocationName(user.lat, user.lon);
            const distance = this.model.currentUserLocation
              ? this.model.calculateDistance(
                  this.model.currentUserLocation.lat,
                  this.model.currentUserLocation.lon,
                  user.lat,
                  user.lon
                )
              : null;
            this.view.updateSidebarLocationName(user.id, name, distance);
          } catch {
            this.view.updateSidebarLocationName(user.id, 'Lokasi tidak tersedia');
          }
        }
      }
    } catch (e) {
      this.view.showSidebarError(
        this.model.nearbyDistance,
        () => this.appInterface.toggleDistanceDialog()
      );
      if (this.appInterface.reinitTooltips)
        this.appInterface.reinitTooltips();
    }
  }

  async refresh() {
    await this.init();
    if (this.appInterface.reinitTooltips)
      this.appInterface.reinitTooltips();
  }
}
